import React from "react";
import { Card, Theme, Grow, CardHeader } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import makeStyles from "@mui/styles/makeStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const StyledTableCell = withStyles((theme: any) => ({
	head: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white,
		border: "none",
	},
	body: {
		fontSize: 14,
		color: "white",
		border: "none",
	},
}))(TableCell);

const StyledTableRow = withStyles((theme: any) => ({
	root: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.secondary.main,
			opacity: 0.8,
		},
		"&:nth-of-type(even)": {
			backgroundColor: theme.palette.text.disabled,
			opacity: 0.8,
		},
	},
}))(TableRow);

function createData(name: any, date: any) {
	return { name, date };
}

const rows = [
	createData("Personal Training Session", "2:00 pm 09/19/20"),
	createData("Kickboxing Class", "4:00 pm 09/20/20"),
	createData("Yoga Class", "1:00 pm 09/21/20"),
	createData("Spin Class", "7:00 pm 09/22/20"),
];

const useStyles = makeStyles((theme: Theme) => ({
	table: {
		minWidth: 300,
		border: "none",
	},
	cardHeader: {
		backgroundColor: theme.palette.primary.main,
		width: "100%",
		color: "white",
		alignItems: "center",
	},
}));

export default function CustomizedTables() {
	const classes = useStyles();

	return (
		<Grow in={true} timeout={2000}>
			<Card raised={true}>
				<Table className={classes.table} aria-label="customized table">
					<TableHead>
						<CardHeader
							className={classes.cardHeader}
							title="Upcoming Classes"
						/>
						<StyledTableCell align="right">
							Date
						</StyledTableCell>
					</TableHead>
					<TableBody>
						{rows.map((row) => (
							<StyledTableRow key={row.name}>
								<StyledTableCell component="th" scope="row">
									{row.name}
								</StyledTableCell>
								<StyledTableCell align="right">{row.date}</StyledTableCell>
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</Card>
		</Grow>
	);
}
